import React, { useEffect, useState, useRef, useCallback } from 'react'
import SpecialKeysReact from 'special-keys-react'
import { t } from 'translation'
import { addDays, isAfter, differenceInDays } from 'date-fns'
import { connect } from 'react-redux'

import Logo from 'components/Logo/Logo'
import InviteModal from 'components/InviteModal/InviteModal'
import history from 'utils/appHistory'

import TelIcon from '../assets/icons/tel.svg'
import MusicIcon from '../assets/icons/music.svg'
import OrangeMan from '../assets/icons/orange_man_icon.svg'
import { setDemoMode } from '../store/actions'

const WelcomeDoctorPage = (props) => {
  const [isInviteOpen, setIsInviteOpen] = useState(false)
  const [index, setIndex] = useState(-1)

  const mainElement = useRef()
  const btnRef = useRef(new Set())

  useEffect(() => {
    document.documentElement.classList.remove('no_scale_mod')

    mainElement.current.focus()
  }, [])

  useEffect(() => {
    if (!isInviteOpen) {
      mainElement.current.focus()
    } else {
      btnRef.current.clear()
      mainElement.current.focus()
    }
  }, [isInviteOpen])

  useEffect(() => {
    SpecialKeysReact.config({
      left: () => {},
      right: () => {},
      up: () => {},
      down: () => {
        if (isInviteOpen) return
        if (!isInviteOpen && btnRef.current.size > 0) {
          Array.from(btnRef.current)[
            index + 1 > btnRef.current.size - 1 ? 0 : index + 1
          ].focus()
          setIndex(index + 1 > btnRef.current.size - 1 ? 0 : index + 1)
        }
      },
      backspace: () => {},
      enter: () => {
        if (!isInviteOpen && btnRef.current.size > 0)
          Array.from(btnRef.current)[index].click()
      },
    })
  }, [index])

  const freeDaysRemaining = isAfter(
    addDays(props.userCreatedDate, props.freeDays),
    new Date()
  )

  // const daysRemaining = differenceInDays(
  //   addDays(props.userCreatedDate, props.freeDays),
  //   props.userCreatedDate
  // )

  const daysRemaining =
    differenceInDays(props.userCreatedDate, new Date()) + props.freeDays

  return (
    <>
      <div ref={mainElement} {...SpecialKeysReact.events} tabIndex="1">
        {!isInviteOpen && (
          <section className="section offset_v2_mod session_type_mod">
            <div className="section_in center_content_mod">
              <div className="session_type_content">
                <ul className="session_type_list">
                  <li className="session_type_item">
                    <button
                      ref={(btn) => (!btn ? null : btnRef.current.add(btn))}
                      className="session_type_item_btn"
                      onClick={() => setIsInviteOpen(true)}
                    >
                      <figure className="session_type_item_graph">
                        <figcaption className="session_type_item_info">
                          <h3 className="session_type_item_title default_text offset_mod">
                            <div className="session_type_img">
                              <TelIcon className="icon size_mod" />
                            </div>
                            {t('welcome.PRESCRIBE_MUSIC_CARE')}
                          </h3>
                        </figcaption>
                      </figure>
                    </button>
                  </li>
                  {!props.subscribed && !freeDaysRemaining && (
                    <li className="session_type_item">
                      <button
                        ref={(btn) => (!btn ? null : btnRef.current.add(btn))}
                        className="session_type_item_btn"
                        onClick={() => (
                          history.push('/indication-select'), props.setDemoMode(true)
                        )}
                      >
                        <figure className="session_type_item_graph">
                          <figcaption className="session_type_item_info">
                            <h3 className="session_type_item_title default_text">
                              <div className="session_type_img">
                                <MusicIcon className="icon size_mod" />
                              </div>
                              {t('welcome.MAKE_DEMONSTRATION')}
                              <div className="session_type_item_descr_v2">
                                {t('welcome.PREVIEW_MUSIC')}
                              </div>
                            </h3>
                          </figcaption>
                        </figure>
                      </button>
                    </li>
                  )}
                  {freeDaysRemaining && (
                    <li className="session_type_item">
                      <button
                        ref={(btn) => (!btn ? null : btnRef.current.add(btn))}
                        className="session_type_item_btn"
                        onClick={() => (
                          history.push('/indication-select'), props.setDemoMode(false)
                        )}
                      >
                        <figure className="session_type_item_graph">
                          <figcaption className="session_type_item_info">
                            <h3 className="session_type_item_title default_text">
                              <div className="session_type_img">
                                <MusicIcon className="icon size_mod" />
                              </div>
                              {t('welcome.USE_PERSONAL')}
                              <div className="session_type_item_descr_v2">
                                {daysRemaining} {t('welcome.DAYS_LEFT')}
                              </div>
                            </h3>
                          </figcaption>
                        </figure>
                      </button>
                    </li>
                  )}
                  {props.subscribed && !freeDaysRemaining && (
                    <li className="session_type_item">
                      <button
                        ref={(btn) => (!btn ? null : btnRef.current.add(btn))}
                        className="session_type_item_btn"
                        onClick={() => history.push('/welcome')}
                      >
                        <figure className="session_type_item_graph">
                          <figcaption className="session_type_item_info">
                            <h3 className="session_type_item_title default_text offset_mod">
                              <div className="session_type_img">
                                <MusicIcon className="icon size_mod" />
                              </div>
                              {t('welcome.NEW_SUBSCRIPTION')}
                            </h3>
                          </figcaption>
                        </figure>
                      </button>
                    </li>
                  )}
                  {!props.subscribed && !freeDaysRemaining && (
                    <li className="session_type_item">
                      <button
                        ref={(btn) => (!btn ? null : btnRef.current.add(btn))}
                        className="session_type_item_btn"
                        onClick={() =>
                          !window.cordova
                            ? history.push('/subscription')
                            : history.push('/access')
                        }
                      >
                        <figure className="session_type_item_graph">
                          <figcaption className="session_type_item_info">
                            <h3 className="session_type_item_title default_text">
                              <div className="session_type_img">
                                <OrangeMan className="icon size_mod" />
                              </div>
                              {t('welcome.REGISTER_FOR')}
                              <div className="session_type_item_descr_v2">
                                {t('welcome.UNLIMITED_ACCESS')}
                              </div>
                            </h3>
                          </figcaption>
                        </figure>
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="player_bottom_wrap">
              <div className="player_bottom v2_mod">
                <Logo modClass="bar_mod" />
              </div>
            </div>
          </section>
        )}
        <InviteModal
          isInviteModalOpen={isInviteOpen}
          toggleInviteHandler={() => setIsInviteOpen(!isInviteOpen)}
        />
      </div>
    </>
  )
}

const mapStateToProps = ({ auth: { error, attributes } }) => ({
  authError: error,
  userCreatedDate: new Date(attributes.userCreatedDate),
  attributes,
  freeDays: attributes.licenses.freeDays,
  subscribed: JSON.parse(attributes.subscribed || false),
})

const willMapDispatchToProps = {
  setDemoMode,
}

export default connect(mapStateToProps, willMapDispatchToProps)(WelcomeDoctorPage)
